// @flow
import React, { Component } from 'react';
import { StyleSheet } from 'react-native';
import { Secon, Text } from 'trpc-react-native-ui';

import I18n from '../../../../lib/i18n';
import theme from '../../../../theme-config';
import { Modal, SecondaryFullButton } from '../../../../components/common';

type Props = {
  buttonText: string,
  content?: string,
  handleMaxTries?: Function,
  hasReachedMaxTries?: boolean,
  isVisible: boolean,
  onPress: any,
  title: string,
};

class ErrorModal extends Component<Props> {
  render() {
    const { content, title, buttonText, handleMaxTries, hasReachedMaxTries, isVisible, onPress } = this.props;

    return (
      <Modal visible={isVisible} requestClose={onPress} style={styles.modalContainer}>
        <Text style={styles.modalTitle}>{title}</Text>
        {!!content && <Text style={styles.modalContent}>{content}</Text>}

        <SecondaryFullButton text={buttonText} onPress={onPress} />
        {hasReachedMaxTries && (
          <Text onPress={handleMaxTries} style={styles.manualInputText}>
            {I18n.t('SignUp.IdScan.modalError.manualInput')}
          </Text>
        )}
      </Modal>
    );
  }
}

const styles = StyleSheet.create({
  manualInputText: {
    color: theme.primaryColor,
    fontWeight: 'bold',
    marginTop: 20,
    textAlign: 'center',
  },
  modalContainer: {
    borderRadius: 0,
    paddingHorizontal: 15,
    paddingVertical: 20,
  },
  modalContent: {
    color: theme.gray.normal,
    marginBottom: 50,
  },
  modalTitle: {
    color: theme.primaryColor,
    fontWeight: 'bold',
    marginBottom: 10,
    marginTop: 50,
  },
});

export default ErrorModal;
